/** @module SiteAdmin/3DDocumentForm **/
define([
	"dojo/_base/declare",
	"underscore",
	"csi/action/_3DFileValidationMixin",
	"csi/comm/Aspera",
	"csi/def",
	"csi/def/Field",
	"csi/html",
	"csi/form/Widget",
	"csi/locale",
	"csi/util",
	"csi/xml",
], function(declare, _, ThreeDFileValidationMixin, Aspera, def, Field, html, Widget, locale, util, xml) {

	const SOURCE_FILE = "SourceFile";
	const CLO_HARDWARE_EXTENSIONS = ["trm", "btn", "bth", "zpac", "sst", "zsp", "zpl", "zsd", "zfab"];

	return declare([Widget, ThreeDFileValidationMixin], {
		fileIndexNode: null,
		warnMsg: "",
		_setCheckMessageAttr: {node: "checkMessageNode", type: "innerText"},

		/** @param {Object} asperaData - internal structure to hold Aspera connection data between aspera calls */
		asperaData: null,

		/** @param {boolean} showColoredMaterialDom - determines whether or not to show the propagate to color material checkbox */
		showColoredMaterialDom: true,

		constructor: function() {
			this._initializeFileType(this.EXTENSIONS);
			this.fileLabel = locale.resource("3DZip");
		},

		startup: function() {
			var dfd = this.inherited(arguments);

			// Prevent message rows from being duplicated on startup
			if (!this.messageRowCreated) {
				//fill in default message when no files are selected
				this.on3DZipFile(true);
				this.messageRowCreated = true;
			}

			return dfd;
		},

		/**
		 * Creates the file message row
		 * @param {boolean} [bIsRequired]
		 * @param {string} [fileName]
		 */
		on3DZipFile: function(bIsRequired, fileName) {
			//move required items to top of the row
			var messageRowNode = html.create("div", {
				"class": "csi-3Dform-fileIndex-row"
			}, this.fileIndexNode, bIsRequired && "first");

			html.create("div", {
				innerHTML: (bIsRequired ? (fileName ? 'check_circle' : 'brightness_1') : '&nbsp;'),
				"class": "csi-3Dform-fileIndex-left" + (bIsRequired ? (" material-icons " + (fileName ? "csi-status-ok" : "")) : "")
			}, messageRowNode);

			var requiredFileText = locale.resource("3DObjectFiles");

			this.checkMessageNode = html.create("div", {
				"class": "csi-3Dform-check-message"
			}, messageRowNode);
			this.set("checkMessage", fileName || requiredFileText);
		},

		/**
		 * Extension point on3Dzip file selection
		 * @param {array} val
		 */
		onZipRead: function(val) { },

		/**
		 * Form validation , make Data value available to action controller
		 * @param {Object} errorParams
		 */
		validateForm: function(errorParams) {
			var val = this.inherited(arguments);
			var formData = this.defView.getFormData();
			var field = formData.getField(SOURCE_FILE);
			var documentName = this.defView.getFieldValue(xml.ATTR_NAME);

			if (field && field.errorMessage) {
				errorParams.message = field.errorMessage;
				val = false;
			} else if ((!field && !Aspera.isEnabled()) || (Aspera.isEnabled() && !this.asperaData)) { // Don't validate zip file if Aspera. Because problem with missed File blob in Aspera. TBD with IBM.
				field = this.getField(SOURCE_FILE);
				errorParams.message = locale.resource(!documentName ? "Error3DNoFileName" : (field.getValue() ? "" : "Error3DNoFile"));
				val = false;
			}
			return val;
		},

		/**
		 * Change Label for upload field
		 */
		_resolveView: function() {
			this.inherited(arguments);
			var fileField = this.getField(SOURCE_FILE);
			fileField.typeControl = def.FIELD_CUSTOM;
			fileField.widgetParams.accept = ".zip,.zfab,.trm,.btn,.bth,.zpac,.sst,.zsp,.zpl,.zsd,.u3ma,.sbsar";
			fileField.m_label = this.fileLabel;
		},

		/**
		 * @override
		 * On file select check if its a valid zip file
		 * @param {Obj} defView
		 * @param {Field} field
		 * @param {Any} value
		 * @param {Object} params - parameter from base class
		 * @param {Object} asperaFile - Aspera replacement for File blob object. Can't be used for Zip parsing
		 */
		_onChangeFileField: function(defView, field, value, params, asperaFile) {
			var self = this;
			var bWarning = false;
			this.showColoredMaterialDom = true;

			//Set wanted file object
			var fileToRead = asperaFile || field.m_control.files[0];
			$(this.fileIndexNode).empty();

			if (!fileToRead) {
				//fill in default message when no files are selected
				this.on3DZipFile(true);
			} else {
				//pre-fill Document name field from file name if the field is blank
				var textField = this.getField(xml.ATTR_NAME);

				if (textField.isDefaultValue() || !textField.getValue()) {
					var fileName = fileToRead.name.substr(0, fileToRead.name.lastIndexOf('.'));
					// remove path if any (Added for Aspera)
					fileName = fileName.substring(fileName.lastIndexOf('/') + 1);
					fileName = fileName.substring(fileName.lastIndexOf('\\') + 1);

					this.setFieldValue(textField, fileName);
				}

				var ext = util.getFileExtension(fileToRead.name);

				if (_.contains(CLO_HARDWARE_EXTENSIONS, ext)) {
					this.showColoredMaterialDom = false;
				}
			}

			field.errorMessage = "";
			this.warnMsg = "";
			if (asperaFile) {
				let coloredMaterialDom = this.domNode.querySelector(".csi-3D-Material-checkbox");
				this.on3DZipFile(true, asperaFile.name);

				if (coloredMaterialDom) {
					let ext = util.getFileExtension(asperaFile.name);

					if (_.contains(CLO_HARDWARE_EXTENSIONS, ext)) {
						html.hide(coloredMaterialDom);
					} else {
						html.show(coloredMaterialDom);
					}
				}

			} else if (util.getFileExtension(fileToRead.name) == "sbsar") {
				self.hideCheckboxField(true);
			} else {
				this.validate3DZip(fileToRead).then(function(val) {
					bWarning = !!val.bWarning;
					field.errorMessage = bWarning ? "" : val.message;
					self.warnMsg = bWarning && val.message;
					self.errorForm(field.errorMessage);
					self.onZipRead(val);
				});
			}
		},

		/**
		 * @override
		 * Replace standard "Select File" button with custom one to use with Aspera,
		 */
		onDrawCreateFileIndexNode: function(defView, field, value, div, control, widgetParam) {
			this.inherited(arguments);
			if (Aspera.isEnabled()) {
				html.clear(div);
				html.create("button", {
					innerText: locale.resource("3DSelectFile"),
					"class": "",
					onclick: (event) => this._onClickFileField(event)
				}, div);
			}

			// Make sure button is enabled
			this.setFieldDisabled(SOURCE_FILE, false);
		},

		/**
		 * Custom "Select File" button callback
		 * @param {MouseEvent} event
		 */
		_onClickFileField: function(event) {
			event.preventDefault();
			var self = this;
			Aspera.selectFile({
				allowedFileTypes: [{
					filter_name: locale.resource("3DZip"),
					extensions: ["zip", "zfab", "trm", "btn", "bth", "zpac", "sst", "zsp", "zpl", "zsd"]
				}]
			}).then(function(data) {
				self.asperaData = data;
				var field = self.getField(SOURCE_FILE);
				self._onChangeFileField(null, field, null, null, data.files[0]);
			},
				function(msg) {
					// suppress error if user cancel file selection
				}
			);
		}
	});
});